import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Box } from "lucide-react";

const navItems = [
  { to: "/converters", label: "Converters" },
  { to: "/calculators", label: "Calculators" },
  { to: "/text-tools", label: "Text Tools" },
];

export const Header = () => {
  const { pathname } = useLocation();
  return (
    <header className="border-b-2 border-ink bg-paper sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-5 sm:px-8 h-[68px]">
        <Link to="/" data-testid="logo-home-link" className="flex items-center gap-2 group">
          <span className="w-9 h-9 bg-signal border-2 border-ink flex items-center justify-center shadow-brutalSm group-hover:rotate-6 transition-transform">
            <Box className="w-5 h-5 text-paper" strokeWidth={2.5} />
          </span>
          <span className="font-heading font-black text-2xl tracking-tight uppercase">
            Utili<span className="text-signal">verse</span>
          </span>
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2">
          {navItems.map((n) => {
            const active = pathname.startsWith(n.to);
            return (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`font-bold text-xs sm:text-sm uppercase tracking-wider px-3 py-2 border-2 transition-all ${
                  active
                    ? "border-ink bg-ink text-paper"
                    : "border-transparent hover:border-ink hover:bg-canvas"
                }`}
              >
                {n.label}
              </Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
};
